<template lang="pug">
  .date-filter
    span.filter-title {{ $t('common.begin_end_date') }}
    //- format="dd/MM/yyyy HH:mm"
    el-date-picker(
      v-model="dateRange"
      type="datetimerange"
      align="right"
      format="dd/MM/yyyy hh:mm a"
      :start-placeholder="$t('common.start_date')"
      :end-placeholder="$t('common.end_date')"
      :picker-options="pickerOptions"
      :default-value="new Date()"
      @change="emitChangeEvent"
    )
</template>

<script>
import { dateRangeShortcuts, disabledFutureDates } from "@utils/dateRange";

export default {
  name: "FilterDatePicker",

  props: {
    value: {
      type: Array,
      default: () => [],
    },

    resetSignal: {
      type: [String, Number], // Can be a timestamp, counter, etc.
      default: null,
    },
  },

  data() {
    const now = new Date();
    const startOfToday = new Date(now);
    startOfToday.setHours(0, 0, 0, 0);

    return {
      fallbackDateRange: [startOfToday, now],

      pickerOptions: {
        disabledDate(time) {
          return disabledFutureDates(time);
        },
        shortcuts: dateRangeShortcuts,
      },
    };
  },

  computed: {
    dateRange: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },

  mounted() {
    if (!this.value || this.value.length !== 2) {
      this.$emit("input", this.fallbackDateRange);
      this.emitChangeEvent(this.fallbackDateRange);
    }
  },

  watch: {
    value: {
      handler(val) {
        if (!val || val.length !== 2) return;

        const [startRaw, endRaw] = val;
        const start = new Date(startRaw);
        const end = new Date(endRaw);
        const now = new Date();
        let shouldUpdate = false;

        // Always set start to 00:00
        if (start.getHours() !== 0 || start.getMinutes() !== 0 || start.getSeconds() !== 0) {
          start.setHours(0, 0, 0, 0);
          shouldUpdate = true;
        }

        // If end is today, set it to current time
        const isToday =
          end.getFullYear() === now.getFullYear() &&
          end.getMonth() === now.getMonth() &&
          end.getDate() === now.getDate();

        const isMidnight =
          end.getHours() === 0 &&
          end.getMinutes() === 0 &&
          end.getSeconds() === 0;

        if (isToday && isMidnight) {
          end.setHours(now.getHours(), now.getMinutes(), now.getSeconds(), 0);
          shouldUpdate = true;
        } else if (!isToday && isMidnight) {
          end.setHours(23, 59, 59, 999);
          shouldUpdate = true;
        }

        if (shouldUpdate) {
          this.$emit("input", [start, end]);
          this.emitChangeEvent([start, end]);
        }
      },
      immediate: true,
      deep: true,
    },

    resetSignal() {
      const now = new Date();
      const startOfToday = new Date(now);
      startOfToday.setHours(0, 0, 0, 0);

      const newRange = [startOfToday, now];

      this.fallbackDateRange = newRange;
      this.$emit("input", newRange);
      this.emitChangeEvent(newRange);
    },
  },

  methods: {
    emitChangeEvent(values) {
      // if (!values || values.length !== 2) return;
      // const utcValues = values.map(date => date.toISOString());
      // this.$emit("onChange", utcValues);

      if (!values || values.length !== 2) return;

      const utcValues = values.map(date => {
        const d = new Date(date);
        return isNaN(d.getTime()) ? null : d.toISOString();
      });

      this.$emit("onChange", utcValues);
    },

    endIsToday(end) {
      const today = new Date();
      return end.getDate() === today.getDate() &&
             end.getMonth() === today.getMonth() &&
             end.getFullYear() === today.getFullYear();
    },

    startEndAreTheSame(start, end) {
      return start.getDate() === end.getDate() &&
             start.getMonth() === end.getMonth() &&
             start.getFullYear() === end.getFullYear();
    }
  }
};
</script>
